import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
@Component({
  selector: 'app-partner-config',
  templateUrl: './partner-config.component.html',
  styleUrls: ['./partner-config.component.scss'],
})
export class PartnerConfigComponent implements OnInit {
  private readonly notifier: NotifierService;
  boobleModalData: any;
  public loading: boolean;
  configForm!: FormGroup;

  get config(): any {
    const config = this.configForm.value;
    return config;
  }

  constructor(
    private router: Router,
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    formBuilder: FormBuilder,
    private companyService: CorporateAccountService
  ) {
    this.notifier = notifierService;
    this.configForm = formBuilder.group({
      id: [null],
      tariff: [null, [Validators.required, Validators.min(0)]],
      spread: [null, [Validators.required, Validators.min(0), Validators.max(100)]],
      institutionalSpread: [null, [Validators.required, Validators.min(0), Validators.max(100)]],
      spreadBanking: [null, [Validators.required]],
    });
  }

  ngOnInit() {
    this.configForm.controls['tariff'].setValue(this.boobleModalData?.tariff);
    this.configForm.controls['id'].setValue(this.boobleModalData?.id);

    let spreadValue = this.boobleModalData?.spread;
    if (spreadValue != null && spreadValue <= 1) {
      spreadValue = spreadValue * 100;
    }
    this.configForm.controls['spread'].setValue(spreadValue);

    let institutionalSpreadValue = this.boobleModalData?.institutionalSpread;
    if (institutionalSpreadValue != null && institutionalSpreadValue <= 1) {
      institutionalSpreadValue = institutionalSpreadValue * 100;
    }
    this.configForm.controls['institutionalSpread'].setValue(institutionalSpreadValue);

    this.configForm.controls['spreadBanking'].setValue(
      this.boobleModalData?.spreadBanking
    );
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  sendConfig() {
    this.loading = true;

    if (this.configForm.invalid) {
      this.configForm.markAllAsTouched();
      this.loading = false;
      return;
    }

    const formValue = this.configForm.getRawValue();

    const payload = {
      ...formValue,
      spread: formValue.spread != null ? formValue.spread / 100 : null,
      institutionalSpread: formValue.institutionalSpread != null ? formValue.institutionalSpread / 100 : null,
    };

    this.companyService.editPartner(payload).subscribe({
      next: () => {
        this.closeModal();
        this.companyService.updatePartnerView();
        this.notifier.notify('success', 'Configuração salva com sucesso!');
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
